import { memo } from 'react'
import { SxProps } from '@mui/material'
import { useTranslations } from '@/core/translation'
import { Box } from '@/components/Layout'
import { Text } from '@/components/Data'
import { AddOnSummary, FlightSummary, HotelSummary } from '../__components__'
import EventDetails from './EventDetails'
import { summarySidebarStyles as styles } from './SummarySidebar.style'
import { SummarySidebarProps } from './SummarySidebar.types'

function SummarySidebar({
  includeBookingInfo,
  hideLocationInfo = false,
  hideInMobile = false,
}: SummarySidebarProps) {
  const t = useTranslations('addOn')
  return (
    <Box sx={[styles.wrapper, hideInMobile && styles.hideInMobile] as SxProps}>
      <Box sx={styles.detailsCard}>
        <Box sx={styles.summaryCard}>
          <EventDetails hideLocationInfo={hideLocationInfo} />
        </Box>
        <AddOnSummary />
        <HotelSummary />
        <FlightSummary />
      </Box>
      {includeBookingInfo && (
        <Box>
          <Box sx={styles.bookWrapper}>
            <Text sx={styles.bookHeading}>{t('book')}</Text>
            <Text sx={styles.bookDesc}>SEO text paragraph here.</Text>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default memo(SummarySidebar)
